/**
 * event 模块领域事件总线。
 * 采用与 characterLifecycleBus 一致的 key 注册模式：event 侧只负责发布，
 * 消费方（如 history 的主历史投影）自行订阅，避免 event 反向值依赖下游模块。
 */

import type { GameEventEntry } from './types/event';

type GameEventAppendedHandler = (entry: GameEventEntry) => void;

const appendedSubscribers = new Map<string, GameEventAppendedHandler>();

export function registerGameEventAppendedSubscriber(key: string, handler: GameEventAppendedHandler): void {
  appendedSubscribers.set(key, handler);
}

export function unregisterGameEventAppendedSubscriber(key: string): void {
  appendedSubscribers.delete(key);
}

export function emitGameEventAppended(entry: GameEventEntry): void {
  appendedSubscribers.forEach(handler => {
    handler(entry);
  });
}
